import { render, staticRenderFns } from "./TemplateKorrespondenzliste.vue?vue&type=template&id=41976485&"
import script from "./TemplateKorrespondenzliste.vue?vue&type=script&lang=js&"
export * from "./TemplateKorrespondenzliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports